export const POST_CREDITLIMIT_PAGE = 'POST_CREDITLIMIT_PAGE'
export const POST_CREDITLIMIT_PAGE_SUCCESS = 'POST_CREDITLIMIT_PAGE_SUCCESS'

export const GO_BUTTON_FOR_CREDITLIMIT_PAGE = 'GO_BUTTON_FOR_CREDITLIMIT_PAGE'
export const GO_BUTTON_FOR_CREDITLIMIT_PAGE_SUCCESS = 'GO_BUTTON_FOR_CREDITLIMIT_PAGE_SUCCESS'


